// =======================================================
// Variables
// =======================================================

// Const Global
const body              = document.body;
const menu              = document.querySelector('#js-NavMain');
const menuItems         = document.querySelectorAll('#js-NavMain .menu-item-has-children.menu__item');
const menuLinks         = document.querySelectorAll('#js-NavMain .menu-item-has-children .menu__link');

// Const Simple Menu
const menuSimple        = menu.classList.contains('nav-main--simple');
const menuOpen          = document.querySelector('#js-OpenMenu');
const menuClose         = document.querySelector('#js-CloseMenu');
const subMenuCloses     = document.querySelectorAll('.nav-main .submenu__close');

// Const Burger Menu
const menuBurger        = menu.classList.contains('nav-main--burger');
const menuOpenBurger    = document.querySelector('#js-OpenMenu');
const menuCloseBurger   = document.querySelector('#js-CloseMenu');
const menuCloseA11y     = document.querySelector('#js-CloseMenuA11y');
const subMenuClose      = document.querySelector('#js-CloseSubmenu');
const buttonscontainer  = document.querySelector('.nav-main-buttons');


// =======================================================
// Simple responsive Menu
// =======================================================
if (menuSimple) {

    // Check if condition
    // console.log('If classlist contains nav-main--simple');

    // ---------------------------------------------------
    // Open/Close submenu
    // ---------------------------------------------------
    menuLinks.forEach(function (menuLink) {

        function OpenCloseSubmenu(menuLink) {

            // Variables
            let menuLinkParent = menuLink.parentElement;
            let menuLinkParentOpen = menuLinkParent.classList.contains('js-open-submenu');

            menuItems.forEach(function (menuItem) {

                // Variables
                let menuItemOpen  = menuItem.classList.contains('js-open-submenu');
                let submenuLinks    = menuItem.querySelectorAll('.submenu__link');

                // If submenu open : Remove js-open-submenu
                if (menuItemOpen) {

                    // Close submenu
                    menuItem.classList.remove('js-open-submenu');
                    menu.classList.remove('js-open-submenu');

                    // Check class removed
                    // console.log("remove open menu");

                    submenuLinks.forEach(function (submenuLink) {
                        submenuLink.setAttribute('tabindex', -1);
                        // console.log("tabindex-1");
                    });
                }

            });

            // If submenu close : Add js-open-submenu
            if (!menuLinkParentOpen) {

                // Open submenu
                menuLinkParent.classList.add('js-open-submenu');
                menu.classList.add('js-open-submenu');

                // Check class added
                // console.log("add open menu");

                menuItems.forEach(function (menuItem) {
                    let menuItemOpen = menuItem.classList.contains('js-open-submenu');
                    
                    if (menuItemOpen) {
                        let submenuLinks = menuItem.querySelectorAll('.submenu__link');
                        submenuLinks.forEach(function (submenuLink) {
                            submenuLink.setAttribute('tabindex', 0);
                            // console.log("tabindex-0");
                        });
                    }

                });
            }

        }

        // Event click
        menuLink.addEventListener('click', (e) => {
            OpenCloseSubmenu(menuLink);

            e.preventDefault();
            // console.log("e.preventdefault");
        });


        function CloseSubmenu(menuLink) {
            menuItems.forEach(function (menuItem) {

                // Variables
                let menuItemOpen = menuItem.classList.contains('js-open-submenu');
                let submenuLinks = menuItem.querySelectorAll('.submenu__link');

                // If submenu open : Remove js-open-submenu
                if (menuItemOpen) {

                    // Close submenu
                    menuItem.classList.remove('js-open-submenu');
                    menu.classList.remove('js-open-submenu');

                    submenuLinks.forEach(function (submenuLink) {
                        submenuLink.setAttribute('tabindex', -1);
                        // console.log("tabindex-1");
                    });

                    // Check class removed
                    // console.log("remove open menu");
                }

            });
        }
        
        document.addEventListener("mouseup", function(event) {
            if (!menu.contains(event.target)) {
                CloseSubmenu(menuLink);
            }
        });

    });

    // ---------------------------------------------------
    // submenu close
    // ---------------------------------------------------
    subMenuCloses.forEach(function (subMenuClose) {
        subMenuClose.addEventListener('click', function () {
            this.closest('.menu__item').classList.remove('js-open-submenu');

            // Check deleted class
            // console.log("Remove js-open-submenu");
        });
    });


    // ---------------------------------------------------
    // Responsive menu
    // ---------------------------------------------------
    // Open menu
    menuOpen.addEventListener('click', function () {
        menu.classList.add('js-open-menu');
        body.classList.add('js-open-menu');
    });

    // Close menu
    menuClose.addEventListener('click', function () {
        menu.classList.remove('js-open-menu');
        body.classList.remove('js-open-menu');
    });

}


// =======================================================
// Burger Menu
// =======================================================
if (menuBurger) {

    // Check if condition
    // console.log('If classlist contains nav-main--burger');

    // ---------------------------------------------------
    // Open/Close menu (with button a11y for close menu)
    // ---------------------------------------------------

    // Function A11y button active : Tabindex in DOM
    function TabindexDOM(menuCloseA11y) {
        menuCloseA11y.setAttribute('tabindex', 0);
    }

    // Function A11y button inactive : Tabindex removed from DOM
    function TabindexOutDOM(menuCloseA11y) {
        menuCloseA11y.setAttribute('tabindex', -1);
    }

    // Open menu Fonction
    function OpenMenu() {

        // Open menu
        menu.classList.add('js-open-menu');
        body.classList.add('js-open-menu');

        // A11y button active
        TabindexDOM(menuCloseA11y);
    }

    // Close menu Fonction
    function CloseMenu() {
        
        // Close menu
        menu.classList.remove('js-open-menu');
        body.classList.remove('js-open-menu');

        // A11y button inactive
        TabindexOutDOM(menuCloseA11y);
    }

    // Open menu
    menuOpenBurger.addEventListener('click', () => {
        OpenMenu(menuOpenBurger);
    });

    // Close menu
    menuCloseBurger.addEventListener('click', () => {
        CloseMenu(menuCloseBurger);
    });

    // Close menu with A11y button
    menuCloseA11y.addEventListener('click', () => {
        CloseMenu(menuCloseA11y);
    });


    // ---------------------------------------------------
    // Open/Close submenu
    // ---------------------------------------------------

    menuLinks.forEach(function (menuLink) {

        function OpenCloseSubmenu(menuLink) {

            // Variables
            let menuLinkParent = menuLink.parentElement;
            let menuLinkParentOpen = menuLinkParent.classList.contains('js-open-submenu');

            menuItems.forEach(function (menuItem) {

                // Variables
                let menuItemOpen = menuItem.classList.contains('js-open-submenu');

                // If submenu open : Remove js-active-submenu
                if (menuItemOpen) {

                    // Close submenu
                    menuItem.classList.remove('js-open-submenu');
                }

            });

            // If submenu close : Add js-active-submenu
            if (!menuLinkParentOpen) {

                // Open submenu
                menuLinkParent.classList.add('js-open-submenu');
                buttonscontainer.classList.add('js-open-submenu');
                menu.classList.add('js-open-submenu');
            }

        }

        // Event click
        menuLink.addEventListener('click', () => {
            OpenCloseSubmenu(menuLink);
        });

    });


    // ---------------------------------------------------
    // Responsive submenu close
    // ---------------------------------------------------

    subMenuClose.addEventListener('click', function () {

        menuItems.forEach(function (menuItem) {

            // Close submenu
            menuItem.classList.remove('js-open-submenu');
            buttonscontainer.classList.remove('js-open-submenu');
            menu.classList.remove('js-open-submenu');

            // Check deleted class
            // console.log("Remove js-open-submenu");
        });
        
    });

}

//----------------------------------------------------
// home reseaux moved to the burger menu in 960 and under
//----------------------------------------------------
if(body.classList.contains('home') && (window.innerWidth < 960)) {
    let reseaux = document.querySelector('.js-reseaux')
    let menuContainer = document.querySelector('.js-nav-main__container')
    let lastMenuItem = menuContainer.querySelector('.js-menu')
    menuContainer.insertBefore(reseaux, lastMenuItem.nextSibling);
}
